import React from 'react';
import assets from '../../assets/assets';
import MissionVision from '../../component/MissionVision';
import ClientLogoSlider from '../../component/ClientSlider';

const OurHistory = () => {
    const { about_bg } = assets();
    return (
        <main>
            <section class="pt-0 cover-background ipad-top-space-margin sm-pb-0"
                style={{ backgroundImage: `url(${about_bg})` }}>
                <div class="shape-image-animation bottom-0 p-0 w-100 d-none d-md-block">
                    <svg xmlns="http://www.w3.org/2000/svg" widht="3000" height="400" viewBox="0 180 2500 200" fill="#ffffff">
                        <path class="st1" d="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250">
                            <animate
                                attributeName="d"
                                dur="5s"
                                values="M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 400 50 400 400 3000 250 L 3000 550 L 0 550 L 0 250;
                            M 0 250 C 1200 400 1200 50 3000 250 L 3000 550 L 0 550 L 0 250"
                                repeatCount="indefinite"
                            />
                        </path>
                    </svg>
                </div>
                <div class="container">
                    <div class="row align-items-center justify-content-center h-500px sm-h-300px">
                        <div class="col-12 col-xl-6 col-lg-8 col-md-10 position-relative text-center page-title-extra-large d-flex flex-wrap flex-column align-items-center justify-content-center" data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                            <span class="ps-25px pe-25px pt-5px pb-5px mb-15px text-uppercase text-white fs-12 ls-1px fw-600 border-radius-100px bg-gradient-dark-gray-transparent d-flex"><i class="bi bi-megaphone text-white icon-small me-10px"></i>World class business services</span>
                            <h1 class="mb-20px text-white fw-600 ls-minus-1px">Our History</h1>
                        </div>
                    </div>
                </div>
            </section>

            <section id="down-section" class="border-bottom border-color-extra-medium-gray">
                <div class="container overlap-gap-section">
                    <div class="row align-items-end justify-content-center mb-5 md-mb-40px text-center text-md-start">
                        <div class="col-xl-5 col-lg-6 col-md-10 md-mb-20px text-center text-lg-start" data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>
                            <span class="ps-25px pe-25px py-3 text-uppercase text-base-color fs-14 fw-700 border-radius-100px bg-gradient-very-light-gray-transparent d-inline-block">About company</span>
                            <h3 class="text-dark-gray fw-700 mb-0 ls-minus-1px">Powerful agency for corporate business.</h3>
                        </div>
                        <div class="col-xl-6 col-lg-6 col-md-10 offset-xl-1 text-center text-lg-start last-paragraph-no-margin">
                            <p class="w-90 xl-w-100" data-anime='{ "el": "lines", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 300, "easing": "easeOutQuad" }'>We strive to develop real-world web solutions that are ideal for small to large projects with bespoke project requirements. we compelling web, <span class="fw-600 text-dark-gray text-decoration-line-bottom">which are the right-fit for your target.</span></p>
                        </div>
                    </div>
                    {/* <div class="row row-cols-1 row-cols-lg-4 row-cols-md-2 row-cols-sm-2 justify-content-center" data-anime='{ "el": "childs", "translateY": [30, 0], "opacity": [0,1], "duration": 600, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>

                        <div class="col custom-icon-with-text-style-02">
                            <div class="feature-box p-6 last-paragraph-no-margin overflow-hidden md-mb-20px">
                                <div class="feature-box-icon">
                                    <img class="custom-image-icon mb-20px" alt="" data-cfsrc="images/demo-corporate-about-icon-01.png" style="display:none;visibility:hidden;" /><noscript><img class="custom-image-icon mb-20px" src="images/demo-corporate-about-icon-01.png" alt="" /></noscript>
                                </div>
                                <div class="feature-box-content">
                                    <span class="d-block fs-19 fw-700 text-dark-gray mb-5px">Trusted company</span>
                                    <p>We deliver email marketing campaigns to audience.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col custom-icon-with-text-style-02">
                            <div class="feature-box p-6 last-paragraph-no-margin overflow-hidden md-mb-20px">
                                <div class="feature-box-icon">
                                    <img class="custom-image-icon mb-20px" alt="" data-cfsrc="images/demo-corporate-about-icon-02.png" style="display:none;visibility:hidden;" /><noscript><img class="custom-image-icon mb-20px" src="images/demo-corporate-about-icon-02.png" alt="" /></noscript>
                                </div>
                                <div class="feature-box-content">
                                    <span class="d-block fs-19 fw-700 text-dark-gray mb-5px">Professional work</span>
                                    <p>We also help our clients with social media strategy.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col custom-icon-with-text-style-02">
                            <div class="feature-box p-6 last-paragraph-no-margin overflow-hidden xs-mb-20px">
                                <div class="feature-box-icon">
                                    <img class="custom-image-icon mb-20px" alt="" data-cfsrc="images/demo-corporate-about-icon-03.png" style="display:none;visibility:hidden;" /><noscript><img class="custom-image-icon mb-20px" src="images/demo-corporate-about-icon-03.png" alt="" /></noscript>
                                </div>
                                <div class="feature-box-content">
                                    <span class="d-block fs-19 fw-700 text-dark-gray mb-5px">Award winning</span>
                                    <p>We believe in challenges so we have made challenges.</p>
                                </div>
                            </div>
                        </div>

                        <div class="col custom-icon-with-text-style-02">
                            <div class="feature-box p-6 last-paragraph-no-margin overflow-hidden">
                                <div class="feature-box-icon">
                                    <img class="custom-image-icon mb-20px" alt="" data-cfsrc="images/demo-corporate-about-icon-04.png" style="display:none;visibility:hidden;" /><noscript><img class="custom-image-icon mb-20px" src="images/demo-corporate-about-icon-04.png" alt="" /></noscript>
                                </div>
                                <div class="feature-box-content">
                                    <span class="d-block fs-19 fw-700 text-dark-gray mb-5px">Help any time</span>
                                    <p>We never fail for support for your business anywhere.</p>
                                </div>
                            </div>
                        </div>
                    </div> */}
                </div>
            </section>

            <section style={{ marginTop: '-2rem' }} class="py-0 sm-pt-50px" data-anime='{ "translateY": [0, 0], "opacity": [0,1], "duration": 1200, "delay": 0, "staggervalue": 150, "easing": "easeOutQuad" }'>
                <div class="container overlap-section">
                    <div class="row justify-content-center g-0">
                        <div class="col-auto text-center last-paragraph-no-margin icon-with-text-style-08 pt-20px pb-20px ps-8 pe-8 md-ps-30px md-pe-30px bg-white border border-color-extra-medium-gray box-shadow-medium-bottom border-radius-100px xs-border-radius-10px">
                            <div class="feature-box feature-box-left-icon-middle overflow-hidden">
                                <div class="feature-box-icon me-10px">
                                    <i class="bi bi-chat-text icon-extra-medium text-base-color"></i>
                                </div>
                                <div class="feature-box-content last-paragraph-no-margin text-dark-gray text-uppercase fs-15 fw-700 ls-05px">
                                    Let's make something great work together. <a href="#" class="text-base-color text-decoration-line-bottom-medium border-1">Got a project in mind?</a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            <div className='m-0 p-0'>
                <MissionVision />
            </div>

            <div className='m-0 p-0'>
                <ClientLogoSlider />
            </div>
        </main>
    );
};

export default OurHistory;